export default __webpack_public_path__ + "static/media/roku-oneview-formerly-dataxu.38eb688c.svg";